import React, {useState, useCallback} from "react";
import {useToggle} from 'react-use';
import {useRouteMatch, useParams} from 'react-router-dom';

import "./style.scss";
import useTabTopics from '../../../useHook/useTabTopics';
import Tabs from '../../../components/Tabs';
import GameModal from './GameModal';

function TabGame(props) {
    const {url} = useRouteMatch();
    const {id} = useParams();
    
    const {menus, menuHelper, onUpdateTitleTopic, onCreateTopic, onCreateExistTopic} = useTabTopics('game',[
        {name: props.tabs[0], to: `${url}`, exact: false},
        {name: props.tabs[1], to: `${url}/game-2`, exact: false},
    ]);

    const [editIndex, setEditIndex] = useState(-1);
    const [modal, toggleModal] = useToggle(false);

    const onSaveTitle = useCallback(async (item, index) => {
        setEditIndex(-1);
        await onUpdateTitleTopic({
            topicId: item.id,
            title: item.name,
        });
        setEditIndex(-1);
        menuHelper.updateAt(index, item)
    }, []);

    const onUpdateTitle = useCallback((index) => {
        setEditIndex(index)
    }, []);

    const onAddFreeTopic = useCallback((useDefault) => {
        if(useDefault === 0) {
            onCreateTopic(useDefault);
            return;
        }
        toggleModal(true);
    }, []);

    const onSaveGameTopic = useCallback((topicGame) => {
        onCreateExistTopic(id, {topic_id: topicGame.id});
        toggleModal(false);
    }, []);

    return (
        <>
            <Tabs menuList={menus}
                  popupList={[
                      { value: 0, name: 'Free Topicsを追加'},
                      { value: 1, name: '既存Topicsを追加'},
                  ]}
                  style={{paddingLeft: 0}}
                  editIndex={editIndex}
                  onAddFreeTopic={onAddFreeTopic}
                  onSaveTitle={onSaveTitle}
                  onUpdateTitle={onUpdateTitle}
            />
            {modal && <GameModal onClose={toggleModal}
                                 onSave={onSaveGameTopic}
            />}
        </>
    );
}

export default TabGame;
